import { LoadingOverlay } from "@sunrun/experience-ui-components";

const SplatLogin = () => {
  return <LoadingOverlay message="Logging in..." />;
};

export { SplatLogin };
